export enum ADD_ON_TYPES {
  DENTAL = 'dental',
  VISION = 'vision'
}

export enum APPLICATION_TYPES {
  ADD_ON_DENTAL = 'add-on-dental',
  ADD_ON_VISION = 'add-on-vision',
  DELEGATION = 'delegation',
  DENTAL = 'dental',
  HEALTH = 'health',
  HEALTH_TEMP = 'health_temp',
  MEDICAL = 'medical',
  MEDICAL_TRANSITIONER = 'medical-transitioner',
  MEDICARE = 'medicare',
  SMALL_BUSINESS = 'small-business',
  VISION = 'vision'
}

export const APPLICATION_ID_PREFIX: Record<APPLICATION_TYPES, string> = {
  [APPLICATION_TYPES.ADD_ON_DENTAL]: 'D',
  [APPLICATION_TYPES.ADD_ON_VISION]: 'V',
  [APPLICATION_TYPES.DELEGATION]: 'DG',
  [APPLICATION_TYPES.DENTAL]: 'D',
  [APPLICATION_TYPES.HEALTH]: 'H',
  [APPLICATION_TYPES.HEALTH_TEMP]: 'TMP',
  [APPLICATION_TYPES.MEDICAL]: 'M',
  [APPLICATION_TYPES.MEDICAL_TRANSITIONER]: 'MT',
  [APPLICATION_TYPES.MEDICARE]: 'MC',
  [APPLICATION_TYPES.SMALL_BUSINESS]: 'SB',
  [APPLICATION_TYPES.VISION]: 'V'
};

export enum LEGACY_APPLICATION_TYPES {
  ADD_ON_DENTAL = 'add_on_dental',
  ADD_ON_VISION = 'add_on_vision',
  DELEGATION = 'delegation',
  DENTAL = 'application_dental',
  HEALTH = 'application_health',
  HEALTH_TEMP = 'health_temp',
  MEDICAL = 'medical',
  MEDICAL_TRANSITIONER = 'medical_transitioner',
  MEDICARE = 'medicare',
  SMALL_BUSINESS = 'application_small_business',
  VISION = 'application_vision'
}
